// The device token: the API bearer, bound to the user by the gateway at
// sign-in. Same shape as onlycat-admin's OCPlatform ("WE" + 8 hex), kept in
// localStorage under the same key. Web only, so no Ionic Storage / SQLite.
const KEY = "deviceToken";

let cached: string | undefined;

export function generateNewToken(): string {
  // OCPlatform mixes the clock into Math.random; crypto is better randomness
  // for the same format the gateway already accepts.
  const bytes = new Uint8Array(4);
  crypto.getRandomValues(bytes);
  return "WE" + Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getDeviceToken(): string {
  if (cached) return cached;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored) return (cached = stored);
  } catch {
    // Private mode or blocked storage: a token for this tab only.
  }
  cached = generateNewToken();
  try { localStorage.setItem(KEY, cached); } catch { /* see above */ }
  return cached;
}

/** After logout the old token is dead; start the next sign-in with a fresh one. */
export function resetDeviceToken(): void {
  cached = undefined;
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
